import React from 'react';
import Button from './Button';

interface AnimatedButtonProps {
  to: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

const AnimatedButton: React.FC<AnimatedButtonProps> = ({ to, children, icon }) => {
  return (
    <Button 
      variant="outline" 
      size="lg" 
      to={to}
      className="group relative overflow-hidden border-2 border-brand shadow-amber-200/30 shadow-lg hover:shadow-2xl transition-all duration-500 !bg-transparent hover:!bg-transparent"
    >
      <span className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand to-accent-rose opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <span className="absolute inset-0 -translate-y-full bg-gradient-to-b from-white/40 via-transparent to-transparent group-hover:translate-y-full transition-transform duration-700 ease-out" />
      <span className="relative z-10 flex items-center justify-center gap-2 font-semibold text-brand group-hover:text-white transition-colors duration-500">
        {icon && <span className="group-hover:scale-125 transition-transform duration-300">{icon}</span>}
        <span>{children}</span>
      </span>
    </Button>
  );
};

export default AnimatedButton;
